import { ConfirmModal } from "../../../../components/ui";
import { DropDownList } from "../../../../components/ui";
import EditScopeCustomAddressModal from "../workScopeEdit/EditScopeCustomAddressModal";
import EditScopeCustomTimeModal from "../workScopeEdit/EditScopeCustomTimeModal";
import useDispatchScopeActions from "./useDispatchScopeActions";

/**
 * Shared Dispatch WorkScopeAspect action menu. Used by edit cards as the visible
 * ellipsis menu and by view cards as an invisible menu opened from right-click.
 */
export default function DispatchScopeActionMenu({
  scope,
  date,
  align,
  className = "",
  buttonIcon = "ellipsis",
  showButton = true,
  openKey,
  disableCopy = false,
}) {
  const actions = useDispatchScopeActions({ scope, disableCopy });

  return (
    <>
      <DropDownList
        listItems={actions.menuItems}
        date={date}
        buttonIcon={buttonIcon}
        align={align}
        className={className}
        showButton={showButton}
        openKey={openKey}
      />
      <EditScopeCustomAddressModal {...actions.customAddressModal} />
      <EditScopeCustomTimeModal {...actions.customTimeModal} />
      <ConfirmModal {...actions.deleteModal} />
    </>
  );
}
